/**
 * Protoss Document Contract
 * ──────────────────────────
 * A declarative, JSON-serialisable description of a Word Document (.docx)
 * rendered by the docx package, and of a Google Doc rendered by the
 * google-docs package (both consume this same contract).
 *
 * provider:       "docx"
 * schemaVersion:  "0.0.1" (legacy) | "0.1.0" (adds lists, page breaks,
 *                 headers/footers, signature blocks, content injection)
 *
 * These hand-written interfaces are the source of truth for the TYPES.
 * `contract.zod.ts` provides a runtime validator typed as
 * `z.ZodType<DocumentContract>`, so the two cannot drift structurally.
 */
/**
 * Usable page content width in dxa (≈468pt at 1" margins). The even-split budget
 * for table columns when no per-column widths are authored. Matches the contract
 * dynamicBlock width budgets and the signature-block layout.
 */
export const TABLE_CONTENT_WIDTH_DXA = 9360;
/**
 * Even-split column widths (dxa) for a table with `colCount` columns. A table
 * with no explicit `columnWidths` collapses on Google Docs export, so every
 * table is given at least an even split.
 */
export function evenColumnWidths(colCount) {
    const n = Math.max(1, colCount);
    return Array.from({ length: n }, () => Math.floor(TABLE_CONTENT_WIDTH_DXA / n));
}
//# sourceMappingURL=contract.js.map